import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './theme.css';
import App from './App';

// Invite and password-reset links land on the site root with the token in the address hash.
// Send them to the set-password page (the hash stays, so the sign-in still completes).
const h = window.location.hash;
if (/type=(invite|recovery)/.test(h) && window.location.pathname !== '/set-password') {
  window.history.replaceState(null, '', '/set-password' + h);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
